module.exports = __webpack_public_path__ + "static/605b4804-fe48-4a0d-927e-ba92b5ce300e-original.7cd19322.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-katharines-chapel-window/605b4804-fe48-4a0d-927e-ba92b5ce300e-original.jpg
// module id = 1121
// module chunks = 168707334958949